{
  "key": "ridge-rd-quarter-acre",
  "title": "Ridge Rd quarter-acre",
  "suburb": "Gumtree Heights",
  "locationGroup": "backyards",
  "grassType": "kikuyu",
  "cellM": 0.5,
  "w": 28,
  "h": 50,
  "rows": [
    "eeeeeeeeeeeeeeeeeeeeeeeeeeee",
    "egggggggggggggggggggbbbbbbbe",
    "egbbbbbggggggggggggggooooooe",
    "egbbbbbggggggggggggggooooooe",
    "eggggggggggggggggggggooooooe",
    "eggggggggggggggggggggbbbbbbe",
    "eggggggggggggggggggggbbbbbbe",
    "eggggggggggggggggggggggggbbe",
    "eggggggggggggggggggggggggbbe",
    "egggggggggggggggggggggggoooe",
    "egggggggggggggggggggggggoooe",
    "egggggggggggggggggbbbgggoooe",
    "eggggggggggogggggbbobggggooe",
    "eggggggggggggggggboobggggbbe",
    "eggggbbbbggggggggbbbbgggbbbe",
    "egggbbbbbbggggggggggggggbbbe",
    "egggbboobbggggggggggggggbbbe",
    "egggbboobbggggggggggggggbbbe",
    "eggggbbbbbgggooooooggggbbbbe",
    "egggggbbbggggooooooggggbbbbe",
    "eggggggggggggggggggggggbbbbe",
    "egggggggggggggggggogggggbbbe",
    "egggggggggggggggggggggggggge",
    "epppppppppppppppppppgpppppge",
    "epppppppppppppppppppgpppppge",
    "epppppppppppppppppppgpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "e...................gpppppge",
    "eggggggggggggggggggggpppppge",
    "eggggggggggggggggggggpppppge",
    "eggggggggggggggggggggpppppoe",
    "pppppppppppppppppppppppppppp",
    "pppppppppppppppppppppppppppp",
    "gggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggg",
    "pppppppppppppppppppppppppppp",
    "............................",
    "............................",
    "............................"
  ],
  "zoneRows": [
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "............................",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "............................",
    "............................",
    "............................",
    "............................"
  ],
  "zones": [
    {"id":"nature-strip","rangeMm":[50,70]}
  ],
  "rangeMm": [45,65],
  "startLengthMm": [100,150],
  "props": [
    {"id":"house","kind":"house","x":5.25,"y":15.75,"w":9.5,"h":5.5,"solid":true,"penalty":false},
    {"id":"shed-1","kind":"shed","x":12,"y":1.6,"w":3,"h":2.2,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":3.6,"y":8.4,"r":0.5,"solid":true,"canopyR":4},
    {"id":"gum-tree-2","kind":"gum-tree","x":9.6,"y":6.6,"r":0.45,"solid":true,"canopyR":3.6},
    {"id":"hills-hoist-1","kind":"hills-hoist","x":5.9,"y":6.1,"r":0.2,"solid":true,"canopyR":2.4},
    {"id":"veggie-bed-1","kind":"veggie-bed","x":8.1,"y":9.4,"w":3,"h":1.2,"solid":true},
    {"id":"dog-bowl-1","kind":"dog-bowl","x":9.4,"y":10.8,"r":0.15,"solid":true},
    {"id":"cubby-1","kind":"cubby","x":12.6,"y":5.1,"w":1.6,"h":1.6,"solid":true},
    {"id":"water-tank-1","kind":"water-tank","x":12.9,"y":6.1,"r":0.55,"solid":true},
    {"id":"letterbox-1","kind":"letterbox","x":13.1,"y":19.9,"w":0.4,"h":0.3,"solid":true},
    {"id":"brick-edging-1","kind":"brick-edging","x":8.1,"y":10.25,"w":3.2,"h":0.15,"solid":false}
  ],
  "spawn": {"x":11.75,"y":18.75,"heading":-1.5707963267948966},
  "utePark": {"x":11.75,"y":19.75,"heading":-1.5707963267948966},
  "weedFraction": 0.12,
  "leaves": {"count":[160,240],"areas":[{"x":0.5,"y":4,"w":7,"h":8},{"x":7.5,"y":9,"w":6,"h":7}]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["veggie-bed","above-ground-pool","magpie-season","sprinkler","heavy-leaves","ibis","lost-ball","hot-day"],
  "slope": {"x":0,"y":-0.14}
}
